'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../../../../../styleInject.js');

var css_248z = ".ActionOption-module_action__tSAGR{align-items:center;grid-template-columns:1rem 1fr 1rem}";
var styles = {"action":"ActionOption-module_action__tSAGR"};
styleInject["default"](css_248z, 'f39ef726-d34d-4fb0-bd28-cabdebaf3acb');

exports["default"] = styles;
